import { isSameDay, format } from 'date-fns';
import type { Reservation } from '@app-types/models/reservation';

export const formatTime = (slotIndex: number, startHour: string): string => {
  const [startHours, startMinutes] = startHour.split(':').map(Number);
  const totalMinutes = (slotIndex * 15) + (startHours * 60) + startMinutes;
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
};

export const formatDisplayTime = (timeStr: string): string => {
  const [hours, minutes] = timeStr.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHour = hours % 12 || 12;
  return `${displayHour}:${minutes.toString().padStart(2, '0')} ${period}`;
};

export const getRelativeDay = (dayIndex: number, startDayOffset: number): string | undefined => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const date = new Date();
  date.setDate(date.getDate() + dayIndex + startDayOffset);

  if (date.toDateString() === today.toDateString()) {
    return `Today`;
  } else if (date.toDateString() === yesterday.toDateString()) {
    return `Yesterday`;
  } else if (date.toDateString() === tomorrow.toDateString()) {
    return `Tomorrow`;
  }
};

export const calendarFormatDate = (dayIndex: number, startDayOffset: number): string => {
  const date = new Date();
  date.setDate(date.getDate() + dayIndex + startDayOffset);
  const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'short' });
  return `${format(date, 'dd/M')} ${dayOfWeek}`;
};

// Check if there's any conflicting reservation
export const hasReservationConflict = (
  reservationData: Reservation[],
  rearrangingReservation: Reservation,
  newStart: Date,
  newEnd: Date
): boolean => {
  return reservationData.some(reservation => {
    // Skip checking against the reservation being rearranged
    if (reservation._id === rearrangingReservation._id) return false;

    const reservationStart = new Date(new Date(reservation.start).setSeconds(0, 0));
    const reservationEnd = new Date(new Date(reservation.end).setSeconds(0, 0));

    // Check if dates are the same
    if (!isSameDay(newStart, reservationStart)) return false;

    // Check for overlap
    return !(
      (newEnd <= reservationStart) ||
      (newStart >= reservationEnd)
    );
  });
};
